import { CreateAccountInput, Member } from '@cpd-app/core-module/models';
import {
  InviteUsersMutationVariables,
  SaveUserDetailsMutationVariables,
  User,
  VerifyEmailMutationVariables
} from '@cpd-app/generated';
import { createAction, props } from '@ngrx/store';

export const getUsers = createAction('[User] get users');

export const getUsersSuccess = createAction(
  '[User] get users success',
  props<{ users: Member[] }>()
);

export const getUsersFailure = createAction(
  '[User] get users failure',
  props<{ error: any }>()
);

export const getEmailToVerify = createAction(
  '[User] get email to verify',
  props<{ token: string }>()
);

export const getEmailToVerifySuccess = createAction(
  '[User] get email to verify success',
  props<{ email: string }>()
);

export const getEmailToVerifyFailure = createAction(
  '[User] get email to verify failure',
  props<{ error: any }>()
);

export const saveUser = createAction(
  '[User] save user',
  props<{ input: SaveUserDetailsMutationVariables }>()
);

export const deleteUser = createAction(
  '[User] delete user',
  props<{ userId: number }>()
);

export const saveUserSuccess = createAction(
  '[User] save user success',
  props<{ profile: Member }>()
);

export const saveUserFailure = createAction(
  '[User] save user failure',
  props<{ error: any }>()
);

export const inviteUsers = createAction(
  '[User] invite users',
  props<{ input: InviteUsersMutationVariables }>()
);

export const deleteUserSuccess = createAction(
  '[User] delete user success',
  props<{ success: boolean }>()
);

export const deleteUserFailure = createAction(
  '[User] delete user failure',
  props<{ error: any }>()
);
export const inviteUsersSuccess = createAction(
  '[User] invite users success',
  props<{ success: boolean }>()
);

export const inviteUsersFailure = createAction(
  '[User] invite users failure',
  props<{ error: any }>()
);

export const verifyEmail = createAction(
  '[User] verify email',
  props<{ input: VerifyEmailMutationVariables }>()
);

export const verifyEmailSuccess = createAction(
  '[User] verify email success',
  props<{ success: boolean; verifiedEmail: string }>()
);

export const verifyEmailFailure = createAction(
  '[User] verify email failure',
  props<{ error: any }>()
);

export const accountProcess = createAction('[User] account process');

export const createAccount = createAction(
  '[User] create account',
  props<{
    input: CreateAccountInput;
  }>()
);

export const createAccountSuccess = createAction(
  '[User] create account success',
  props<{ user: User }>()
);

export const createAccountFailure = createAction(
  '[User] create account failure',
  props<{ error: any }>()
);

export const resetPassword = createAction(
  '[User] reset password',
  props<{
    email: string;
  }>()
);

export const resetPasswordSuccess = createAction(
  '[User] reset password success',
  props<{ success: boolean }>()
);

export const resetPasswordFailure = createAction(
  '[User] reset password failure',
  props<{ error: any }>()
);

export const changePassword = createAction(
  '[User] change password',
  props<{
    token: string;
    password: string;
  }>()
);

export const changePasswordSuccess = createAction(
  '[User] change password success',
  props<{ account: Member }>()
);

export const changePasswordFailure = createAction(
  '[User] change password failure',
  props<{ error: any }>()
);
